import forEach from 'lodash/forEach';
import { validateNodeWithCharacters } from '~lib/common/validators/caseLogicDescription/characters/validateNodeWithCharacters';
import { validateRequiredFields } from '~lib/common/validators/caseLogicDescription/requiredFields/validateRequiredFields';

function validateAttentionNodes(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];

  // Effect nodes
  nodeInfo.effectNodes.forEach((node) => {
    const nodeType = 'effect';
    const controlTypes = ['ATTENTION', 'NPC_ATTENTION'];
    const characterErrors = validateNodeWithCharacters(node, nodeType, controlTypes, caseConf) || [];
    if (characterErrors.length > 0) errors.push(...characterErrors);

    const requiredFields = [
      {
        key: 'attentionType',
        label: 'Attention Type',
        errorId: 'attentionType',
        article: 'an'
      },
      {
        key: 'sourceCharacterKey',
        label: 'Source Character',
        errorId: 'missingSourceCharacter'
      },
      {
        key: 'targetCharacterKey',
        label: 'Target Character',
        errorId: 'missingTargetCharacter'
      },
    ]
    const missingFieldErrors = validateRequiredFields(requiredFields, node, nodeType, controlTypes) || [];
    if (missingFieldErrors.length > 0) errors.push(...missingFieldErrors);
  });

  // Check nodes
  nodeInfo.checkNodes.forEach((node) => {
    const nodeType = 'check';
    const controlTypes = ['ATTENTION', 'NPC_ATTENTION'];
    forEach(node.data, (check, checkKey) => {
      const characterErrors = validateNodeWithCharacters(node, nodeType, controlTypes, caseConf, checkKey) || [];
      if (characterErrors.length > 0) errors.push(...characterErrors);

      const requiredFields = [
        {
          key: 'attentionType',
          label: 'Attention Type',
          errorId: 'attentionType',
          article: 'an'
        },
        {
          key: 'sourceCharacterKey',
          label: 'Source Character',
          errorId: 'missingSourceCharacter'
        },
        {
          key: 'targetCharacterKey',
          label: 'Target Character',
          errorId: 'missingTargetCharacter'
        },
      ]
      const missingFieldErrors = validateRequiredFields(requiredFields, node, nodeType, controlTypes, checkKey) || [];
      if (missingFieldErrors.length > 0) errors.push(...missingFieldErrors);
    })
  });

  return {
    errors,
    warnings,
  };
}

export default validateAttentionNodes;
